import type * as React from 'react';
import styled from 'styled-components';
import type { IconProps as MuiIconProps } from '@material-ui/core/Icon';
import MuiIcon from '@material-ui/core/Icon';

const StyledIcon = styled(MuiIcon)``;

export type DSIconProps = MuiIconProps;
export const DSIcon: React.FC<DSIconProps> = StyledIcon;
